'use client';

import { useTranslations } from 'next-intl';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

interface Props {
    duration: number;
    onTimeElapsed?: () => void;
}

export function Countdown({ duration, onTimeElapsed }: Props) {
    const intervalHandleRef = useRef<NodeJS.Timeout>();

    const t = useTranslations();

    const [startTime, setStartTime] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);

    const timeRemaining = useMemo(
        () => Math.round((duration * 1000 - (currentTime - startTime)) / 1000),
        [currentTime, startTime, duration],
    );

    const handleTick = useCallback(() => {
        setCurrentTime(Date.now());
    }, []);

    useEffect(() => {
        if (timeRemaining <= 0) {
            onTimeElapsed?.();
        }
    }, [onTimeElapsed, timeRemaining]);

    useEffect(() => {
        setStartTime(Date.now());
        setCurrentTime(Date.now());

        intervalHandleRef.current = setInterval(handleTick, 1000);

        return () => {
            if (intervalHandleRef.current != null) {
                clearInterval(intervalHandleRef.current);
            }
        };
    }, [handleTick]);

    return <div>{t('general.dateTime.seconds', { amount: timeRemaining })}</div>;
}
